import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const BasemapsAddonsSwitchContainer = styled(Box).attrs(({ theme }) => ({
  backgroundColor: 'background',
  paddingX: '16px',
  borderRight: `1px solid ${theme.colors.lightLineDivider}`,
}))`
  &:last-child {
    border-right: none;
  }
`;
